import { render } from "./NewsFeed.vue?vue&type=template&id=62ce76a5&scoped=true"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"

import "./news-feed.scss?vue&type=style&index=0&id=62ce76a5&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ce76a5"]])

export default __exports__